// Datos de la boda — edita para personalizar.
export const wedding = {
  bride: "Macarena",
  groom: "Virginia",
  monogram: "M / V",
  tagline: "Dos vidas, un mismo cielo.",
  dateISO: "2027-06-04T18:00:00+02:00",
  dateLong: "Viernes, cuatro de junio",
  year: "Dos mil veintisiete",
  timeReadable: "A las seis de la tarde",
  city: "Granada",
  region: "Granada",
  country: "España",
  venueCeremony: {
    name: "Cortijo de Enmedio",
    address: "Carr. de la Zubia, 103D · 18006 Granada",
    detail:
      "La ceremonia se celebrará entre olivos y jardines, con la Sierra Nevada de fondo y la luz dorada del atardecer granadino.",
  },
  venueReception: {
    name: "Cortijo de Enmedio",
    address: "Patio principal y jardines",
    detail:
      "Cena al aire libre, baile en el patio y la mejor sobremesa bajo el cielo de Granada.",
  },
  rsvpDeadline: "31 de marzo de 2027",
  contactEmail: "Próximamente",
  googleFormEmbedUrl: "",
  // Pega aquí la URL de embed de tu playlist de Spotify (https://open.spotify.com/embed/playlist/...)
  spotifyPlaylistUrl:
    "https://open.spotify.com/embed/playlist/0IbddzZWpAfR4LjVv736r0?utm_source=generator",
  // Pega aquí el enlace de PayPal o Stripe para el fondo de la casa
  giftUrl: "https://paypal.me/macayvir",
};

// Métodos de pago — estructurados como array para poder añadir Stripe u otros más adelante.
export const paymentMethods = [
  {
    id: "bank-transfer-es",
    type: "bank_transfer",
    label: "Transferencia bancaria (España · EUR)",
    accountHolder: "Macarena Sturmo y Virginia Pérez",
    iban: "ES46 1563 2626 3832 6490 1645",
    bic: "",
  },
  {
    id: "bank-transfer-pe",
    type: "bank_transfer",
    label: "Interbank (Perú · PEN)",
    accountHolder: "Macarena Sturmo",
    accountNumber: "0453066898018",
    accountNumberLabel: "Cuenta Simple Soles",
    cci: "00304501306689801823",
  },
];

export const travel = [
  {
    label: "Cómo llegar",
    title: "Aeropuerto de Granada (GRX)",
    body:
      "El más cercano al cortijo — aproximadamente 20 min en coche. Málaga (AGP) es una buena alternativa con más vuelos internacionales, a 1 h 30 min por autovía.",
  },
  {
    label: "Dónde alojarse",
    title: "Centro de Granada",
    body:
      "Recomendamos hospedaros en el centro histórico o en el Albaicín. Hoteles con encanto como Palacio de Santa Inés o Casa Morisca. Reservad con tiempo — junio es alta temporada.",
  },
  {
    label: "Dónde alojarse",
    title: "La Zubia · Cerca del cortijo",
    body:
      "Si preferís estar a un paso de la ceremonia, La Zubia y Cájar tienen apartamentos y hoteles rurales muy cómodos. A 5 minutos en coche del Cortijo de Enmedio.",
  },
  {
    label: "En la ciudad",
    title: "Un par de recomendaciones",
    body:
      "Visitad la Alhambra al atardecer, dad un paseo por el Albaicín, y no os perdáis las tapas gratis en Calle Elvira. Sacromonte para flamenco de verdad.",
  },
];

export const faqs = [
  {
    q: "¿Cuál es el código de vestimenta?",
    a: "La única etiqueta es que os sintáis guapísimos. Todo lo demás nos da bastante igual.",
  },
  {
    q: "¿Puedo llevar acompañante?",
    a: "Por motivos de organización, la confirmación de asistencia es únicamente para las personas invitadas. Si tenéis cualquier duda, estaremos encantadas de ayudaros.",
  },
  {
    q: "¿Los niños son bienvenidos?",
    a: "Sí, los niños son bienvenidos. Solo os pedimos que nos lo confirméis con antelación para que el equipo de cocina les prepare su propio menú.",
  },
  {
    q: "¿Habrá transporte?",
    a: "No habrá transporte organizado. El cortijo está en la propia Granada, así que podéis llegar en taxi sin problema — y volver de la misma manera al terminar la noche.",
  },
  {
    q: "¿Puedo ir en coche? ¿Hay parking?",
    a: "Sí, si venís en coche podéis aparcar dentro del cortijo sin problema.",
  },
  {
    q: "¿Y si tengo alguna intolerancia alimentaria?",
    a: "Sin problema — contádnoslo cuando confirméis la asistencia y el equipo de cocina lo tendrá todo previsto. Nada quedará al azar.",
  },
  {
    q: "¿Y si llueve?",
    a: "Que no os preocupéis. En junio en Granada llueve poco y el cortijo tiene salones y galerías cubiertas preciosas. Plan B contemplado.",
  },
];

export const registry = [
  {
    name: "Nuestra luna de miel",
    body: "Un mes por Japón — cerezos, templos y trenes bala. Cualquier aportación se convierte en un recuerdo inolvidable.",
    link: "#",
  },
  {
    name: "Nuestra primera casa",
    body: "Estamos montando una biblioteca pequeña y una cocina muy grande. Cada libro y cada cazuela encuentran su sitio.",
    link: "#",
  },
];

export const navLinks = [
  { id: "story", label: "Historia" },
  { id: "date", label: "La Fecha" },
  { id: "location", label: "Lugar" },
  { id: "logistica", label: "Granada", route: true },
  { id: "faq", label: "FAQ" },
  { id: "rsvp", label: "RSVP" },
  { id: "gifts", label: "Regalos" },
];

export const images = {
  // Media del hero: puede ser imagen (.png/.jpg), gif (.gif) o vídeo (.mp4/.webm/.mov)
  // Si es vídeo, se reproducirá en loop, silenciado y auto-play.
  heroMedia:
    "https://customer-assets.emergentagent.com/job_love-story-site-26/artifacts/ro4pyasf_v.mp4",
  // Recorte de la imagen dentro del asset (solo aplica si heroMedia es una imagen con márgenes).
  // Deja null si tu vídeo/gif ya está recortado al ratio de la tira.
  heroMediaCrop: {
    aspectRatio: "26.8 / 72.2",
    backgroundSize: "373% auto",
    backgroundPosition: "center center",
  },
  photoboothStrip:
    "https://customer-assets.emergentagent.com/job_love-story-site-26/artifacts/vrldtrru_hero.png",
  heroBW: "https://images.pexels.com/photos/2908569/pexels-photo-2908569.jpeg",
  heroFormal: "https://images.pexels.com/photos/17241434/pexels-photo-17241434.jpeg",
  venueFloral: "https://images.pexels.com/photos/20043048/pexels-photo-20043048.jpeg",
  venueOutdoor: "https://customer-assets-gfyr7b9c.emergentagent.net/job_love-story-site-26/artifacts/k081jqjd_WhatsApp%20Image%202026-07-26%20at%2021.40.06.jpeg",
  tableSetting:
    "https://images.unsplash.com/photo-1710587385270-08f30d66bf31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjB3ZWRkaW5nJTIwdGFibGUlMjBzZXR0aW5nfGVufDB8fHx8MTc4MzU4MjE5NXww&ixlib=rb-4.1.0&q=85",
};
